import { IBookmark } from "./IBookmark";

export class Bookmark {
  constructor(
    public isEnable: boolean,
    public value: string,
    public row: number,
    public column: number
  ) {
  }
  
  clone(): Bookmark {
    return new Bookmark(this.isEnable, this.value, this.row, this.column);
  }

  static from(source: IBookmark): Bookmark {
    return new Bookmark(source.isEnable, source.value, source.row, source.column);
  }

  static to(source: Bookmark): IBookmark {
    return {
      isEnable: source.isEnable,
      value: source.value,
      row: source.row,
      column: source.column,
    };
  }
}
